module.exports = __webpack_public_path__ + "img/have-read.f40c6968.svg";